import React from 'react';
import {ChevronRight} from 'lucide-react';
import {cn} from '@/lib/utils';

const Breadcrumbs = ({list}: {
    list: {
        id: string;
        name: string;
    }[]
}) => {
    return <nav
        className="flex"
        aria-label="Breadcrumb">
        <ol className="inline-flex items-center">
            {list.filter(Boolean).map((it, index) => {
                const isLast = index === list.length - 1;
                return (
                    <li className="inline-flex items-center" key={it.id}>
                        <p className={cn("inline-flex items-center text-[0.625rem] font-medium", {
                            "text-muted-foreground": !isLast,
                        })}>
                            {it.name}
                            {!isLast && <ChevronRight className="inline-flex w-4 h-4 text-slate-700" />}
                        </p>
                    </li>
                )
            })}
        </ol>
    </nav>
};

export default Breadcrumbs;
